var _g, _g2, _ellipse, _g3, _g4, _g5, _g6, _g7, _ellipse2, _g8, _g9, _g0, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHorns(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 696,
    height: 593,
    viewBox: "0 0 696 593",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_932_747)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.3815 723.422L50.2122 712.337C81.7351 644.607 115.458 594.739 161.772 555.155C207.986 515.656 267.179 485.092 350.577 453.197L329.191 390.087C250.926 423.504 184.789 458.174 132.067 508.786C79.3253 559.418 39.9714 626.041 15.3815 723.422Z",
    fill: "url(#paint0_linear_932_747)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M131.107 507.715C184.163 456.781 250.715 421.981 329.316 388.458L330.002 388.166L352.337 454.076L351.713 454.314C268.041 486.275 208.833 516.827 162.675 556.278C116.853 595.443 83.8517 643.412 52.5669 710.335L52.9605 710.196L52.1807 711.162C52.0871 711.363 51.9936 711.564 51.9 711.765L51.7505 712.086L51.5282 711.97L50.5138 713.226L14.998 724.325L14.9868 724.329L14.8898 724.359L13.7804 724.03L13.8675 723.684C38.5027 625.718 78.0349 558.664 131.107 507.715ZM50.2122 712.337L15.3815 723.422C39.9714 626.041 79.3253 559.418 132.067 508.786C184.789 458.174 250.926 423.504 329.191 390.087L350.577 453.197C267.179 485.092 207.986 515.656 161.772 555.155C115.458 594.739 81.7351 644.607 50.2122 712.337Z",
    fill: "url(#paint1_linear_932_747)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_932_747)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-65.9489 807.819C33.9032 580.234 121.637 488.913 338.345 395.022",
    stroke: "white",
    strokeWidth: 3
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 61.5922,
    cy: 61.5922,
    rx: 61.5922,
    ry: 61.5922,
    transform: "matrix(-0.947099 0.32094 0.32094 0.947099 417.877 332.414)",
    fill: "#000080"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_932_747)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M369.545 408.972C380.975 442.661 417.538 460.733 451.21 449.336C484.882 437.939 502.912 401.39 491.482 367.7C480.052 334.011 443.49 315.939 409.818 327.336C376.146 338.733 358.115 375.282 369.545 408.972Z",
    fill: "url(#paint2_radial_932_747)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_932_747)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M387.579 397.354C395.523 420.767 420.434 433.496 443.22 425.784C466.005 418.072 478.037 392.839 470.093 369.426C462.15 346.012 437.239 333.284 414.453 340.996C391.667 348.708 379.636 373.94 387.579 397.354Z",
    fill: "url(#paint3_radial_932_747)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_932_747)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M407.089 387.075C411.06 398.781 423.516 405.146 434.909 401.29C446.301 397.434 452.317 384.817 448.345 373.111C444.374 361.404 431.918 355.04 420.525 358.896C409.133 362.752 403.117 375.368 407.089 387.075Z",
    fill: "url(#paint4_radial_932_747)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_932_747)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-27.2297 643.965L19.8073 628.217C61.2075 535.675 105.956 467.326 167.996 412.675C229.903 358.142 309.602 315.47 422.117 270.501L391.819 185.3C286.3 232.23 197.262 280.615 126.749 350.36C56.2106 420.131 4.16196 511.33 -27.2297 643.965Z",
    fill: "url(#paint5_linear_932_747)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M125.424 348.926C196.384 278.738 285.983 230.168 391.957 183.087L392.881 182.677L424.524 271.658L423.682 271.994C310.796 317.057 231.076 359.714 169.243 414.181C107.862 468.252 64.0553 534.01 22.9617 625.452L23.493 625.256L22.4546 626.583C22.3316 626.857 22.2087 627.131 22.0858 627.406L21.8895 627.845L21.5855 627.692L20.2345 629.418L-27.7317 645.198L-27.7468 645.203L-27.8779 645.246L-29.39 644.822L-29.2787 644.35C2.16248 510.921 54.4443 419.134 125.424 348.926ZM19.8073 628.217L-27.2297 643.965C4.16196 511.33 56.2106 420.131 126.749 350.36C197.262 280.615 286.3 232.23 391.819 185.3L422.117 270.501C309.602 315.47 229.903 358.142 167.996 412.675C105.956 467.326 61.2075 535.675 19.8073 628.217Z",
    fill: "url(#paint6_linear_932_747)"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_f_932_747)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-11.561 638.555C78.4785 424.707 159.106 338.233 360.098 247.562",
    stroke: "white",
    strokeWidth: 3
  }))), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 90.2213,
    cy: 94.4003,
    rx: 90.2213,
    ry: 94.4003,
    transform: "matrix(-0.942199 0.335054 0.335054 0.942199 494.404 92.3043)",
    fill: "#000080"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_f_932_747)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M364.463 203.741C388.027 270.005 459.857 304.972 524.899 281.843C589.941 258.713 623.566 186.246 600.002 119.982C576.438 53.7176 504.608 18.7502 439.566 41.8797C374.524 65.0093 340.899 137.477 364.463 203.741Z",
    fill: "url(#paint7_radial_932_747)"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_f_932_747)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M399.08 180.473C415.456 226.525 464.412 251.169 508.426 235.518C552.439 219.866 574.843 169.846 558.467 123.793C542.09 77.7411 493.134 53.0965 449.121 68.7481C405.107 84.3997 382.703 134.42 399.08 180.473Z",
    fill: "url(#paint8_radial_932_747)"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_f_932_747)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M436.62 159.817C444.808 182.844 469.286 195.166 491.293 187.34C513.3 179.514 524.502 154.504 516.313 131.478C508.125 108.452 483.647 96.1294 461.641 103.955C439.634 111.781 428.432 136.791 436.62 159.817Z",
    fill: "url(#paint9_radial_932_747)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_932_747",
    x: 9.78027,
    y: 388.166,
    width: 346.557,
    height: 344.194,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_932_747"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_932_747",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_932_747",
    x: -97.3223,
    y: 363.646,
    width: 466.264,
    height: 474.776,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15,
    result: "effect1_foregroundBlur_932_747"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_932_747",
    x: 336.111,
    y: 293.923,
    width: 188.806,
    height: 188.827,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15,
    result: "effect1_foregroundBlur_932_747"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_932_747",
    x: 355.132,
    y: 308.743,
    width: 147.408,
    height: 149.293,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15,
    result: "effect1_foregroundBlur_932_747"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_932_747",
    x: 375.865,
    y: 327.769,
    width: 103.705,
    height: 104.647,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15,
    result: "effect1_foregroundBlur_932_747"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_932_747",
    x: -33.3901,
    y: 182.677,
    width: 461.914,
    height: 470.57,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_932_747"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_932_747",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_f_932_747",
    x: -42.9434,
    y: 216.195,
    width: 433.658,
    height: 452.942,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15,
    result: "effect1_foregroundBlur_932_747"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_f_932_747",
    x: 326.938,
    y: 4.74603,
    width: 310.588,
    height: 314.231,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15,
    result: "effect1_foregroundBlur_932_747"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_f_932_747",
    x: 363.719,
    y: 34.0399,
    width: 230.109,
    height: 236.186,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15,
    result: "effect1_foregroundBlur_932_747"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_f_932_747",
    x: 403.939,
    y: 71.6011,
    width: 145.055,
    height: 148.093,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15,
    result: "effect1_foregroundBlur_932_747"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_932_747",
    x1: 301.113,
    y1: 432.384,
    x2: 25.1411,
    y2: 708.125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A93D3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_932_747",
    x1: 301.113,
    y1: 432.384,
    x2: 25.1411,
    y2: 708.125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A93D3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_932_747",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(20.696 61.0001 60.9685 -20.6355 430.514 388.336)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#2AC2D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AC2D3",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_932_747",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(14.3833 42.3939 41.2569 -13.9639 428.836 383.39)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#2AC2D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AC2D3",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_932_747",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(7.19167 21.1969 20.6285 -6.98194 427.717 380.093)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00160247,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D01FDF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_932_747",
    x1: 354.579,
    y1: 243.262,
    x2: -14.2971,
    y2: 623.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A93D3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_932_747",
    x1: 354.579,
    y1: 243.262,
    x2: -14.2971,
    y2: 623.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A93D3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_932_747",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(482.233 161.861) rotate(70.4242) scale(127.342 124.994)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#A069A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D01FDF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_932_747",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(478.773 152.133) rotate(70.4242) scale(88.5003 84.5824)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#A069A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D01FDF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_932_747",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(476.467 145.648) rotate(70.4242) scale(44.2501 42.2912)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00160247,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D01FDF",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHorns);
export default __webpack_public_path__ + "static/media/horns.568fcab30558dcf66d9a345a45136fc7.svg";
export { ForwardRef as ReactComponent };